import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { task, waitForProperty } from 'ember-concurrency';

class BrandSignupRoute extends Route {
  @service router;
  @service session;

  activate() {
    super.activate(...arguments);

    this.watchSessionStatus.perform();
  }

  deactivate() {
    super.deactivate(...arguments);

    this.watchSessionStatus.cancelAll({
      resetState: true,
    });

    this.controllerFor('application').setProperties({
      simpleHeaderRightText: '',
      simpleHeaderRightAction: null,
    });
  }

  @task
  *watchSessionStatus() {
    let { currentUser } = this.session;

    while (true) {
      if (currentUser) {
        this.controllerFor('application').setProperties({
          simpleHeaderRightText: 'Logout',
          simpleHeaderRightAction: () => this.router.transitionTo('signout'),
        });
      } else {
        this.controllerFor('application').setProperties({
          simpleHeaderRightText: '',
          simpleHeaderRightAction: null,
        });
      }

      currentUser = yield waitForProperty(
        this.session,
        'currentUser',
        (newValue) => newValue !== currentUser,
      );
    }
  }
}

export default BrandSignupRoute;
